export type CacheEntry<T> = {
  data: T;
  expiryTime: number;
};

export interface ICache {
  get<T>(key: CacheKey): T | undefined;
  set<T>(key: CacheKey, data: T, timeToLive: number): void;
  delete(key: CacheKey): void;
  clear(): void;
}

export type CacheTypes = "teacher" | "school" | "schedule";

export type CacheKey = {
  type: CacheTypes;
  key?: string;
  contexts?: string[];
};

export const cacheKeyToString = ({ type, key, contexts }: CacheKey) => {
  let keyString = `${type}`;
  if (key) {
    keyString += `_${key}`;
  }
  if (contexts?.length) {
    keyString += "__";
    keyString += contexts.sort().join("_");
  }
  return keyString;
};

export const stringToCacheKey = (cacheKey: string): CacheKey => {
  const regex = /^(?!_)(?!.*_$)(?!.*(?:_{3,}))[a-zA-Z0-9_]+$/;
  const parts = cacheKey.split("_");

  if (!regex.test(cacheKey) || (parts.length > 2 && !parts.includes(""))) {
    throw Error("Provided string is not a valid cache key string");
  }

  return {
    type: parts[0] as CacheTypes,
    key: parts[1] !== "" ? parts[1] : undefined,
    contexts: parts.includes("") ? parts.slice(parts.indexOf("") + 1) : undefined,
  };
};

export const cacheKeysEqual = (
  keyA: CacheKey | string,
  keyB: CacheKey | string,
): boolean => {
  const convertedKeyA =
    typeof keyA === "string" ? keyA : cacheKeyToString(keyA);
  const convertedKeyB =
    typeof keyB === "string" ? keyB : cacheKeyToString(keyB);

  return convertedKeyA === convertedKeyB;
};
